import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BehaviorSubject, catchError, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { AccessService } from '../component/navigation/service/access.service';

import moment, { now } from 'moment';
import { environment } from 'src/environments/environment';
import { HelperService } from '../service/helper.service';
import { NavigationComponent } from '../component/navigation/navigation.component';
import { EndPoints } from '../service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class RouteGuardService  {

	useSessionTracker: boolean = true;

    timedOutTime: any = '';
    routeUrl: string = '';
    screenToLoad: string = 'dashboard';
    isLoading: boolean = false;
    loaded$: Observable<boolean>;
    loadedBackupParams$: Observable<boolean>;
    loadedBackupScreen$: Observable<boolean>;
    subs: Subscription[] = [];
    iLoadedRoutingsId: number = 0;
	loadedRoutingsId: string = "";
	iSessionTrackerShellIndex: number = 0;
    backupScreenIds: number[] = [];
	authToken: any = null;
	private guardActive: boolean = false;
	bTimedOut: boolean = false;
	bLastVisited: boolean = false;
	userId: string = "";
	currentUserActivityId: number = 0;
	sessionTrackerShellIndex: string = "";
	myCompInd: string = "";
	myRole: string = "";
	iSessionTrackActivityId: number = 0;


	private getBackupDataSubject = new BehaviorSubject<void>(undefined);


    constructor(
        private accessService: AccessService, 
        private router: Router,         
        private helperService: HelperService
        ) {
			
        }


	triggerGetBackupData(){
		console.log("now calling triggerGetBackupData");
		this.getBackupDataSubject.next();
	}
	
	get backupDataObservable(): Observable<void> {
		console.log("getting backupDataObservable")
		return this.getBackupDataSubject.asObservable();
	}
	


    subscribers() {

    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let routeName = state.url.substring(1);

		if (routeName)
		{
			this.guardActive = true;
		} 

        if (this.guardActive)
		{

			if (routeName != undefined) {
				this.routeUrl = routeName;
				
				return this.accessService.hasRouteaccess(routeName).pipe(
					tap(() => console.log("routeguard pipe NOT WORKING")),
					switchMap((res: boolean) => {
						return of(res);
					}),
					catchError((error) => {
						console.log("error1 in canActivate() for route-guard");
						return of(false);
					})
				);
			} else
			{
				console.log("error2 in canActivate() for route-guard");

				return of(false);
			} 
		}  
		else
		{
			return of(false);
		}         
     }

	 deactivateGuard() {
		this.guardActive = false;
	 }

	 activateGuard() {
		this.guardActive = true;
	 }
}
